import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsPerformanceVasPilot } from 'shared/selectors';
import { selectOfferPromoDescription } from 'shared/selectors/offerData/selectOfferPromoDescription';
import { selectUserType } from 'shared/selectors/user';
import { EUserType } from 'shared/types/user';

import * as styles from './OfferPromotionDescription.css';

export const OfferPromotionDescription = () => {
  const promotionDescription = useSelector(selectOfferPromoDescription);
  const isPromotionVasPilot = useSelector(selectIsPerformanceVasPilot);
  const userType = useSelector(selectUserType);

  if (!promotionDescription || !isPromotionVasPilot || userType === EUserType.Undefined) {
    return null;
  }

  return (
    <div className={styles['wrapper']}>
      <UIText2 fontWeight="bold" color="text-warning-default">
        {promotionDescription}
      </UIText2>
    </div>
  );
};
